import { NumberInput } from '~/components/ui/number-input'
import { useFieldContext } from '~/hooks/form-hooks'
import { Field, type FieldProps } from './field'

type EuroCentsFieldProps = React.ComponentProps<typeof NumberInput> &
  Omit<FieldProps, 'children' | 'error'>

export function EuroCentsField({
  label,
  id,
  optional,
  className,
  labelClassName,
  ...props
}: EuroCentsFieldProps) {
  // `number | undefined` : vider l'input propage `undefined` (clear) → la validation se déclenche.
  const field = useFieldContext<number | undefined>()

  const errorMessage = (field.state.meta.errors as { message: string }[]).at(0)?.message
  // `null` (et non `undefined`) pour un montant vide : `undefined` ferait monter le NumberField
  // de base-ui en non contrôlé, et un `setFieldValue` ultérieur (préremplissage) ne s'afficherait
  // pas. `null` est la valeur « vide » du mode contrôlé.
  const valueInEuros = typeof field.state.value === 'number' ? field.state.value / 100 : null

  return (
    <Field
      label={label}
      id={id}
      optional={optional}
      required={props.required}
      error={errorMessage}
      className={className}
      labelClassName={labelClassName}
    >
      <NumberInput
        {...props}
        className="w-full"
        id={field.name}
        name={field.name}
        onBlur={field.handleBlur}
        onValueChange={(value) => {
          // Clear (input vidé) : on propage undefined pour que la validation se déclenche au lieu
          // de conserver silencieusement l'ancienne valeur.
          field.handleChange(value === null ? undefined : Math.round(value * 100))
        }}
        aria-invalid={errorMessage !== undefined}
        step={0.01}
        value={valueInEuros}
      />
    </Field>
  )
}
